import DoctorPersonalPage from './DoctorPersonalPage';

export default DoctorPersonalPage;